/**
 * @ngdoc Directive
 * @name vrm-dropdown-trigger
 * @example
 *
 */

(function() {
    'use strict';

    angular.module('vrm.components')
        .directive('vrmDropdownTrigger', vrmDropdownTrigger);

    /* @ngInject */
    function vrmDropdownTrigger($rootScope, vrmDropdownEvent) {

        var definition = {
            restrict: 'A',
            link: link
        };


        return definition;

        /**
         * Link
         * @param $scope
         * @param $element
         * @param $attr
         */
        function link($scope, $element, $attr) {
            $element.on('click', function(event) {
                $rootScope.$emit(vrmDropdownEvent.toggle, { id: $attr.vrmDropdownTrigger, target: $element, eventType: event.type });
            });
        }
    }
})();
